enum CompanyAccountSettingsConstants {
  GET_COMPANY_ACCOUNT = '@CompanyAccountSettingsContainer/',
  GET_COMPANY_ACCOUNT_REQUEST = '@CompanyAccountSettingsContainer/GET_COMPANY_ACCOUNT_REQUEST',
  GET_COMPANY_ACCOUNT_REQUEST_SUCCESS = '@CompanyAccountSettingsContainer/GET_COMPANY_ACCOUNT_REQUEST_SUCCESS',
  GET_COMPANY_ACCOUNT_REQUEST_ERROR = '@CompanyAccountSettingsContainer/GET_COMPANY_ACCOUNT_REQUEST_ERROR',

  EDIT_INVOICE_ADDRESS = '@CompanyAccountSettingsContainer/EDIT_INVOICE_ADDRESS',
  EDIT_INVOICE_ADDRESS_REQUEST = '@CompanyAccountSettingsContainer/EDIT_INVOICE_ADDRESS_REQUEST',
  EDIT_INVOICE_ADDRESS_REQUEST_SUCCESS = '@CompanyAccountSettingsContainer/EDIT_INVOICE_ADDRESS_REQUEST_SUCCESS',
  EDIT_INVOICE_ADDRESS_REQUEST_ERROR = '@CompanyAccountSettingsContainer/EDIT_INVOICE_ADDRESS_REQUEST_ERROR',

  RESET_FORM = '@CompanyAccountSettingsContainer/RESET_FORM',
}

export default CompanyAccountSettingsConstants;
